import React, { Component } from 'react';
import '../css/aluno/style_avatar.css';
class render_avatar_pp extends Component {
    render() {

        const foto = {'backgroundImage':`url(${this.props.Foto})`}
        return (
             <div className="hexagon-m" style={foto}>
                <div className="hexTop-m"></div>
                <div className="hexBottom-m"></div>
            </div>
        );
    }
}

export default render_avatar_pp;


// WEBPACK FOOTER //
// ./src/container/render_avatar_m.js